import ArrowLeftOutlined from '@ant-design/icons/ArrowLeftOutlined';
import IdcardOutlined from '@ant-design/icons/IdcardOutlined';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import DollarOutlined from '@ant-design/icons/DollarOutlined';
import WalletOutlined from '@ant-design/icons/WalletOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';

/**
 * O menu do portal do colaborador.
 *
 * <p>
 * Cada item pede a <b>sua</b> permissão `colaboradores.self.*`, e não o prefixo do módulo: é o que
 * faz um prestador que só pede férias não ver a aba de nota fiscal, e o que faz o item "Equipe"
 * aparecer só para quem tem `colaboradores.equipe.*`. O guard de rota repete a exigência — o menu
 * é apresentação, e apresentação não protege nada.
 * </p>
 */
const minhaArea = {
  id: 'group-minha-area',
  title: 'Minha área',
  type: 'group',
  children: [
    {
      id: 'minha-area-voltar',
      title: 'Voltar ao Principal',
      type: 'item',
      url: '/dashboard',
      icon: ArrowLeftOutlined,
      breadcrumbs: false
    },
    {
      id: 'minha-area-resumo',
      title: 'Resumo',
      type: 'item',
      url: '/minha-area',
      icon: IdcardOutlined,
      permissions: ['colaboradores.self.view'],
      breadcrumbs: false
    },
    {
      id: 'minha-area-ferias',
      title: 'Férias',
      type: 'item',
      url: '/minha-area/ferias',
      icon: CalendarOutlined,
      permissions: ['colaboradores.self.ausencias'],
      breadcrumbs: false
    },
    {
      id: 'minha-area-competencias',
      title: 'Meus meses',
      type: 'item',
      url: '/minha-area/competencias',
      icon: DollarOutlined,
      permissions: ['colaboradores.self.competencia'],
      breadcrumbs: false
    },
    {
      id: 'minha-area-reembolsos',
      title: 'Reembolsos',
      type: 'item',
      url: '/minha-area/reembolsos',
      icon: WalletOutlined,
      permissions: ['colaboradores.self.reembolsos'],
      breadcrumbs: false
    },
    {
      id: 'minha-area-documentos',
      title: 'Documentos',
      type: 'item',
      url: '/minha-area/documentos',
      icon: FileTextOutlined,
      permissions: ['colaboradores.self.documentos'],
      breadcrumbs: false
    },
    {
      id: 'minha-area-dados',
      title: 'Meus dados',
      type: 'item',
      url: '/minha-area/meus-dados',
      icon: UserOutlined,
      permissions: ['colaboradores.self.dados'],
      breadcrumbs: false
    },
    {
      id: 'minha-area-equipe',
      title: 'Minha equipe',
      type: 'item',
      url: '/minha-area/equipe',
      icon: TeamOutlined,
      permissionsPrefix: 'colaboradores.equipe.',
      breadcrumbs: false
    }
  ]
};

export default minhaArea;
